export default "__VITE_ASSET__CLqbB8of__"